import React from "react";

const ViewSupportingDocument = ({ supportingDocument }) => {
  const openSupportingDocument = (item) => {
    let url = "";
    let isObjectUrl = false;

    if (item instanceof Blob || item instanceof File) {
      url = URL.createObjectURL(item);
      isObjectUrl = true;
    } else if (typeof item === "string") {
      url = item;
    } else if (item?.url) {
      url = item.url;
    }

    if (!url) return;

    // Fix C-TAB-01: prevent reverse tabnabbing
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");

    // Reset opener reference defensively
    if (newWindow) {
      newWindow.opener = null;
    }

    // Revoke generated object URL after the tab opens to prevent memory leaks
    if (isObjectUrl) {
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    }
  };

  const documents = supportingDocument?.supporting_documents || [];

  return (
    <>
      {documents.length > 0 ? (
        <div className="grid md:grid-cols-5 grid-cols-3 pt-3 gap-3">
          {documents.map((doc, index) => (
            <div
              key={index}
              className="flex justify-between items-center rounded-2xl p-3 review-card-view-supporting-doc-button"
            >
              <button
                type="button"
                className="review-card-view-supporting-doc-text text-sm font-medium underline cursor-pointer px-2 bg-transparent border-none text-left"
                onClick={() => openSupportingDocument(doc)}
              >
                View {index + 1}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <span className="review-card-view-supporting-doc-text text-sm font-medium md:pt-1">
          No Supporting Document
        </span>
      )}
    </>
  );
};

export default ViewSupportingDocument;